import React from 'react';
import { Field } from 'formik';

import styles from './documentsFormStyles';

import AlertStatic from 'buyside/components/presentation/AlertStatic/alertStatic';
import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';
import FileField from 'buyside/components/presentation/Form/Field/FileField/fileField';
import AddRemoveForm from 'buyside/components/presentation/Form/AddRemoveForm/addRemoveForm';

const DocumentsForm = ({
  title,
  attr,
  withCategory,
  withUrl,
  categories,
  withDescription,
  withMargin,
  marketingMaterialsValues
}) => {
  const renderDocument = docPath => {
    const documentKey = docPath.match(/\[(.*?)\]/)[1];
    const documentIndex = parseInt(documentKey);
    const values = marketingMaterialsValues ? marketingMaterialsValues[documentIndex] : null;

    return (
      <div>
        <div className={styles.documentInput}>
          <Field component={InputField} name={docPath + '.name'} label="Name" />
        </div>

        {withUrl && (
          <AlertStatic>
            Share documents by uploading a file or via an external url, such as DocSend.
          </AlertStatic>
        )}

        <Field
          component={FileField}
          disabled={values && withUrl && values.url}
          name={docPath}
          label="File"
        />

        {withUrl && (
          <Field
            disabled={values && values.filename}
            component={InputField}
            name={docPath + '.url'}
            label="URL"
          />
        )}

        {withCategory && (
          <div className={styles.documentInput}>
            <Field
              component={InputField}
              name={docPath + '.category'}
              type="select"
              label="Category"
              options={categories}
            />
          </div>
        )}

        {withDescription && (
          <Field component={InputField} name={docPath + '.description'} label="Description" />
        )}
      </div>
    );
  };

  return (
    <div className={withMargin ? styles.documents : ''}>
      <AddRemoveForm
        title={title}
        attr={attr}
        renderItem={renderDocument}
        itemName="Document"
        blankItem={{ name: '', filename: '', description: '', category: '', url: '' }}
      />
    </div>
  );
};

export default DocumentsForm;
